import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch,  } from 'react-redux';
import {Col, Form,  Label, Modal, ModalBody, ModalHeader, Row} from 'reactstrap';
import {postSetMaintenanceByServiceID} from "../../store/service/actions";


const MaintenanceModal = ({ isOpen, toggle, serviceId}) => {
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({})
  const [formTouched, setFormTouched] = useState({})
  const [durationInMinutes, setDurationInMinutes] = useState("")
  const [alwaysChecked, setAlwaysChecked]  = useState(false)
  
  function handleSubmit() {
    if(alwaysChecked) {
      const payload = {
        duration_in_minutes: -1,
        service_id: serviceId,
      }
      dispatch(postSetMaintenanceByServiceID(payload));
      toggle();
      return;
    }
    handleDurationValidation(durationInMinutes)
    if (Object.keys(formErrors).length === 0){
      if (durationInMinutes === "" ) {
        setFormErrors({...formErrors, duration_in_minutes: "Duration cant be empty"});
        return;
      }
      const duration_in_minutes = parseInt(durationInMinutes);
      if (duration_in_minutes === 0 ) {
        setFormErrors({...formErrors, duration_in_minutes: "Duration cant be 0"});
        return;
      }
      const payload = {
        duration_in_minutes: duration_in_minutes,
        service_id: serviceId,
      }
      dispatch(postSetMaintenanceByServiceID(payload));
      toggle();
    }
  }

  function handleDurationValidation(newValue){
    setFormTouched({...formTouched, duration_in_minutes: true})

    if (newValue === undefined || newValue === null) {
      setFormErrors({...formErrors, duration_in_minutes: "Duration cant be empty"})
    } else if (Number.isInteger(newValue)) {
      setFormErrors({...formErrors, duration_in_minutes: "Duration must be a integer"})
    } else if (newValue < 0) {
      setFormErrors({...formErrors, duration_in_minutes: "Duration cannot be less than 0"})
    } else  {
      setDurationInMinutes(newValue)
      if (newValue !== "") {
        const errors = {...formErrors}
        delete errors.duration_in_minutes
        setFormErrors(errors)
      }
    }
  }

  // function handleAlwaysChecked(e){
  //   setDurationInMinutes("")
  //   setFormErrors({})
  //   setAlwaysChecked(!alwaysChecked)
  // }

  function modalClose() {
    setFormErrors({})
    setFormTouched({})
    setDurationInMinutes("")
    setAlwaysChecked(false)
    toggle()
  }
  return (
    <Modal isOpen={isOpen} toggle={modalClose} centered>
      <ModalHeader toggle={modalClose}>Maintenance Window</ModalHeader>
      <ModalBody>
        <Form
          className='form-horizontal'
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <Row>
            <Col>
              <div className="mb-3">
                <Label htmlFor="duration_in_minutes">Maintenance Length (Minutes)</Label>
                <input
                  id="duration_in_minutes"
                  name="duration_in_minutes"
                  type="number"
                  className="form-control"
                  onChange={(e) => handleDurationValidation(e.target.value)}
                  onBlur={(e) => {setFormTouched({...formTouched, duration_in_minutes: true})}}
                  value={durationInMinutes}
                  placeholder="Enter duration for maintenance"
                  readOnly={alwaysChecked}
                  style={{
                    backgroundColor: 'transparent',
                  }}
                />
                {formErrors.duration_in_minutes && formTouched.duration_in_minutes && (
                  <div className="text-danger">{formErrors.duration_in_minutes}</div>
                )}
              </div>

              {/*<div className="mb-3 d-flex align-content-baseline">*/}
              {/*  <Label style={{ display: 'flex', alignItems: 'center' }}>*/}
              {/*    <i*/}
              {/*      className={*/}
              {/*        alwaysChecked*/}
              {/*          ? 'bx bx-check-square bx-sm'*/}
              {/*          : 'bx bx-square bx-sm'*/}
              {/*      }*/}
              {/*      onClick={handleAlwaysChecked}*/}
              {/*      style={{marginRight: '0.5rem'}}*/}
              {/*    ></i>*/}
              {/*    {"Keep Maintenance Mode Active Until Manually Disabled"}*/}
              {/*  </Label>*/}
              {/*</div>*/}
              <div className="text-end">
                <button type="submit" className="btn btn-primary">
                  Schedule Maintenance
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  );
};

MaintenanceModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  serviceId: PropTypes.string.isRequired,
};

export default MaintenanceModal;
